import { createApp } from 'vue'
import App from './App.vue'
import { gsap } from 'gsap';
window.gsap = gsap;

createApp(App).mount('#app')
